// extracted by mini-css-extract-plugin
module.exports = {"main-course-card":"main-course-card__cK_MC","small-course-card":"small-course-card__189cx"};